import Body from "../../../../../../material/skeleton/Body";
import {Alert, Button, Chip, Slide} from "@mui/material";
import Box from "@mui/material/Box";
import {useEffect} from "react";
import {ArrowBack} from "@mui/icons-material";
import {useNavigate} from "react-router";
import useInterventionRepository from "../../../../../../repository/insurance/useInterventionRepository";
import useQuotationRepository from "../../../../../../repository/insurance/useQuotationRepository";
import isNull from "../../../../../../mixin/isNull";
import LoadingData from "../../../emergency/step/common/LoadingData";
import useHelper from "../../../../../../use/useHelper";
import route from "../../../../../../enum/route";

export default function ({interventionId}) {
    const navigate = useNavigate();
    const helper = useHelper();
    const interventionRepository = useInterventionRepository();
    const quotationRepository = useQuotationRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();
    /** @type Quotation */
    const quotation = quotationRepository.findOneById(intervention?.getQuotationId()).select();

    useEffect(() => {
        interventionRepository.findOneById(interventionId).exec();
    }, []);

    useEffect(() => {
        if (isNull(intervention)) return;

        quotationRepository.findOneById(intervention.getQuotationId()).exec();
    }, [JSON.stringify(intervention)]);

    const handleBack = () => navigate(route.ARTISAN_INTERVENTIONS);

    if (isNull(intervention) || isNull(quotation)) return <LoadingData/>;

    return (
        <Body>
            <Slide in={true} direction={"right"} timeout={500}>
                <Box px={1} mt={2}>
                    {
                        intervention.getClientPrice() > 0
                            ? (
                                <>
                                    <Alert severity={"info"} data-test="insurance-client-billing">
                                        Facturez le sociétaire à hauteur
                                        de {helper.priceFormatter(intervention.getClientPrice() / 100)} €
                                        HT, {helper.priceFormatter((intervention.getClientPrice() / 100) * ((quotation.getVat() / 100) + 1))} €
                                        TTC
                                    </Alert>
                                    <Box mt={10}>
                                        <Alert severity={"info"} data-test="insurance-company-billing">
                                            Facturez FAIRFAIR à hauteur
                                            de {helper.priceFormatter((intervention.getArtisanPrice() / 100) * (isNull(quotation.getVat()) ? 1 : 1.1))} €
                                            TTC
                                        </Alert>
                                    </Box>
                                    <Box mt={15} display="flex" justifyContent="center">
                                        <Chip
                                            label={"L'application est terminée"}
                                            color={"success"}
                                            size="large"
                                        />
                                    </Box>
                                    <Box mt={2}>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            startIcon={<ArrowBack/>}
                                            fullWidth
                                            onClick={handleBack}
                                            data-test="insurance-button-back"
                                        >
                                            Retourner aux interventions
                                        </Button>
                                    </Box>
                                </>
                            )
                            : (
                                <>
                                    <Box mt={10}>
                                        <Alert severity={"info"} data-test="insurance-company-billing">
                                            Facturez FAIRFAIR à hauteur
                                            de {helper.priceFormatter((intervention.getArtisanPrice() / 100) * (isNull(quotation.getVat()) ? 1 : 1.1))} €
                                            TTC
                                        </Alert>
                                    </Box>
                                    <Box mt={15} display="flex" justifyContent="center">
                                        <Chip
                                            label={"L'application est terminée"}
                                            color={"success"}
                                            size="large"
                                        />
                                    </Box>
                                    <Box mt={2}>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            startIcon={<ArrowBack/>}
                                            fullWidth
                                            onClick={handleBack}
                                            data-test="insurance-button-back"
                                        >
                                            Retourner aux interventions
                                        </Button>
                                    </Box>
                                </>
                            )
                    }
                </Box>
            </Slide>
        </Body>
    );
}
